import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const paymentApi = {
    async getPaymentList(params: Pat) {
        return axios.get(`/payment-record/list`, { params });
    },
};

export default paymentApi;
